<template>
    <div
        id="be-condivisione-email-gallery"
        class="bg-light"
    >
        <vue-headful :title="pageTitle" />
        <div class="body-wrapper">
            <main class="pt-0 mt-0">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <form
                        ref="form"
                        @submit.prevent="handleSubmit(onSubmit)"
                    >
                        <div class="barra-titolo-azioni fissa-in-alto bg-white border-bottom py-2 mt-0">
                            <div class="container-fluid">
                                <div class="row d-flex justify-content-between flex-wrap align-items-center">
                                    <div class="col-sm-6 d-flex justify-content-start align-items-center">
                                        <div class="navbar-nav pulsante-indietro">
                                            <a
                                                title="Indietro"
                                                @click="$router.go(-1)"
                                            >
                                                <font-awesome-icon :icon="['fas', 'arrow-left']" />
                                            </a>
                                        </div>

                                        <div class="titolo-status">
                                            <h1 class="mb-0 text-blurikorda">{{ $t("Condividi via email") }}</h1>
                                            <p class="mb-0">
                                                <span class="titolo-gallery small">{{ title }}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 mt-3 mt-sm-0">
                                        <ul class="d-sm-flex justify-content-end flex-wrap mb-0">
                                            <li class="d-inline-block">
                                                <button
                                                    href="#"
                                                    type="submit"
                                                    class="buttonLabel-invia-email-condivisione btn btn-primary btn-rikorda1"
                                                >{{ $t("Invia") }}</button>
                                            </li>
                                            <!--li class="d-inline-block ml-2">
                                                <button
                                                    href="#"
                                                    type="button"
                                                    class="btn btn-light border"
                                                    @click="gotoBackendGallery"
                                                >{{ $t("Annulla") }}</button>
                                            </li-->
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="email d-flex justify-content-between flex-wrap position-relative">
                            <aside class="sidebar-fissa col-sm-4 col-md-5 px-0 bg-white border-right border-left border-bottom">
                                <vue-custom-scrollbar class="scroll-area">
                                    <div class="container-fluid my-3">
                                        <div class="campi-email">
                                            <p class="text-danger mb-0">* {{ $t("Campi obbligatori") }}</p>
                                            <div class="form-group mt-3">
                                                <label for="recipient">
                                                    {{ $t("Invia a") }}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <validation-provider
                                                    rules="required|email|validEmail"
                                                    mode="passive"
                                                    :debounce="5"
                                                    v-slot="{ errors, touched, valid, invalid, pending }"
                                                    tag="div"
                                                    name="E-mail"
                                                >
                                                    <input
                                                        type="email"
                                                        class="form-control"
                                                        :class="{'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                        id="recipient"
                                                        v-model="recipient"
                                                        @change="validate()"
                                                    />
                                                    <span class="text-danger">
                                                        {{
                          errors[0]
                          }}
                                                    </span>
                                                </validation-provider>
                                            </div>
                                            <div class="form-group mt-3">
                                                <label for="subject">
                                                    {{ $t("Oggetto") }}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <validation-provider
                                                    rules="required"
                                                    name="Subject"
                                                    v-slot="{ errors }"
                                                >
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id="subject"
                                                        name="subject"
                                                        v-model="subject"
                                                    />
                                                    <span class="text-danger">
                                                        {{
                          errors[0]
                          }}
                                                    </span>
                                                </validation-provider>
                                            </div>
                                            <div class="form-group mt-3">
                                                <label for="heading">
                                                    {{
                        $t("Intestazione")
                        }}
                                                </label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="heading"
                                                    name="heading"
                                                    v-model="heading"
                                                />
                                            </div>
                                            <div class="form-group mt-3">
                                                <label for="testo-buttonLabel">
                                                    {{
                        $t("Testo del pulsante")
                        }}
                                                </label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="testo-buttonLabel"
                                                    name="testo-buttonLabel"
                                                    v-model="buttonLabel"
                                                />
                                            </div>
                                            <div class="form-group mt-3">
                                                <label for="content">
                                                    {{
                        $t("Corpo dell'email")
                        }}
                                                </label>

                                                <vue-editor
                                                    v-model="content"
                                                    :editor-toolbar="editorToolbar"
                                                    class="form-control"
                                                    id="content"
                                                    name="content"
                                                ></vue-editor>
                                            </div>
                                        </div>
                                    </div>
                                </vue-custom-scrollbar>
                            </aside>

                            <div class="col-sm-8 offset-sm-4 col-md-7 offset-md-5 px-0">
                                <div class="container-fluid mt-3">
                                    <h2 class="mb-0 h6 text-uppercase">{{ $t("Anteprima email") }}</h2>
                                    <div class="anteprima-email mt-3">
                                        <!--anteprima email-->
                                        <div
                                            ref="previewContent"
                                            class="body-mail"
                                            width="100%"
                                            bgcolor="#343a40"
                                            style="width: 100%; margin: 0; padding: 0; background-color: #343a40; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';"
                                        >
                                            <table
                                                cellspacing="0"
                                                cellpadding="0"
                                                border="0"
                                                width="100%"
                                                style="width: 100%; max-width: 600px; margin: 0px auto;"
                                            >
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            valign="middle"
                                                            style="padding: 1rem;"
                                                        >
                                                            <center>
                                                                <p style="margin-top: 0; margin-bottom: 0px; color: #f8f9fa;">
                                                                    <font color="#f8f9fa">
                                                                        {{
                                    $t(
                                    "Sei stato invitato a visionare una gallery"
                                    )
                                    }}
                                                                    </font>
                                                                </p>
                                                            </center>
                                                        </td>
                                                    </tr>
                                                    <tr v-show="coverUrl">
                                                        <td valign="middle">
                                                            <div
                                                                height="350"
                                                                style="width: 100%; height: 350px; background-size: cover; background-position: center; background-repeat: no-repeat;"
                                                                :style="{
                                    'background-image':
                                        'url(' +
                                        coverUrl +
                                        ')'
                                }"
                                                            ></div>
                                                            <!--da aggiustare la fonte dell'immagine-->
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        bgcolor="#ffffff"
                                                        style="background-color: #ffffff;"
                                                    >
                                                        <td
                                                            valign="middle"
                                                            style="padding: 3rem 1rem;"
                                                        >
                                                            <center>
                                                                <h3 style="font-weight: 500; font-size: 16px; line-height: 1.2; text-transform: uppercase; color: #343a40; margin-bottom: 0px; margin-top: 0;">
                                                                    <font color="#343a40">{{ author }}</font>
                                                                </h3>
                                                                <h2 style="font-weight: 500; font-size: 24px; line-height: 1.2; color: #7edbd3; margin-bottom: 0px; margin-top: 1rem;">
                                                                    <font color="#7edbd3">{{ heading }}</font>
                                                                </h2>
                                                                <a
                                                                    :href="buttonLink"
                                                                    target="_blank"
                                                                    bgcolor="#7edbd3"
                                                                    style="padding: 0.5rem; display: inline-block; margin-top: 1rem; background-color: #7edbd3; color: #ffffff; border-radius: 0.25rem; text-transform: uppercase; text-decoration: none;"
                                                                >
                                                                    <font color="#ffffff">{{ buttonLabel }}</font>
                                                                </a>
                                                                <blockquote
                                                                    bgcolor="#f8f9fa"
                                                                    style="margin: 2rem 0 0 0; background-color: #f8f9fa; padding: 2rem;"
                                                                    v-html="content"
                                                                ></blockquote>
                                                            </center>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            valign="middle"
                                                            style="padding: 1rem;"
                                                        >
                                                            <center>
                                                                <p style="margin-bottom: 0px; margin-top: 0; color: #f8f9fa;">
                                                                    <font color="#f8f9fa">Rikorda &copy; 2020 {{ author }}</font>
                                                                </p>
                                                                <!--p style="margin-bottom: 0px; margin-top: 1rem;">
                                                                    <a
                                                                        href="#"
                                                                        style="color: #7edbd3; text-decoration: none;"
                                                                    >
                                                                        <font color="#7edbd3">
                                                                            {{
                                      $t(
                                      "Disiscriviti"
                                      )
                                      }}
                                                                        </font>
                                                                    </a>
                                                                </p-->
                                                            </center>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--anteprima email-->
                                    </div>
                                </div>

                                <footer class="py-3"></footer>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </main>

            <b-modal
                id="bv-modal-example"
                @ok="modalOk"
            >
                <template v-slot:modal-title>{{ $t("Condivisione via mail") }}</template>

                <template v-slot:default>
                    <div class="d-block previous">{{ $t("L'evento è stato condiviso correttamente") }}</div>
                </template>

                <template v-slot:modal-cancel>{{ $t("Chiudi") }}</template>
                <template v-slot:modal-ok>{{ $t("Avanti") }}</template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

export default {
    name: "BackendGalleryShare",
    components: {
        vueCustomScrollbar,
        VueEditor,
        ValidationProvider,
        ValidationObserver
    },

    data() {
        return {
            pageTitle: null,
            eventId: this.$route.params.eventId,
            eventData: null,
            title: null,
            author: null,
            coverUrl: null,
            recipient: null,
            subject: null,
            heading: null,
            buttonLabel: null,
            buttonLink: null,
            content: null,
            editorToolbar: [["bold", "italic", "underline"]]
        };
    },

    mounted() {
        this.$api
            .backendGetEventData(this.eventId)
            .then((result) => {
                console.debug("BACKEND_GET_EVENT_DATA", result);
                this.eventData = result;
                this.title = this.eventData.title;
                this.author = this.eventData.author;
                this.coverUrl = this.$imagesService.getUrl(
                    this.eventData.coverPhotoId,
                    "web"
                );

                // preload data
                this.subject = this.$t("La tua gallery è pronta!");
                this.heading = this.eventData.title;
                this.buttonLabel = this.$t("Vai alla gallery");
                this.buttonLink = this.eventData.eventUrl;
                this.content =
                    this.$t(
                        "Ciao! La tua gallery è pronta per essere visionata. Grazie, "
                    ) + this.author;

                this.setPageTitle();
            })
            .catch((error) => {
                console.error("BACKEND_GET_EVENT_DATA ERROR", error);
            });

        extend("required", {
            ...required,
            message: this.$t("Campo obbligatorio")
        });
        extend("email", {
            ...email,
            message: this.$t("Inserire una e-mail valida")
        });
    },

    methods: {
        setPageTitle() {
            if (this.eventData) {
                this.pageTitle = [
                    this.$t("Condivisione"),
                    this.eventData.title,
                    "- Rikorda"
                ].join(" ");
            }
        },

        onSubmit() {
            var b64PreviewContentHtml = btoa(
                unescape(
                    encodeURIComponent(this.$refs.previewContent.outerHTML)
                )
            );

            console.debug("sharing to", this.recipient);

            this.$api
                .backendShareEvent(
                    this.eventId,
                    this.recipient,
                    this.subject,
                    b64PreviewContentHtml
                )
                .then((result) => {
                    console.debug("BACKEND_SHARE_EVENT", result);
                    this.$bvModal.show("bv-modal-example");
                })
                .catch((error) => {
                    console.error("BACKEND_SHARE_EVENT", error);
                });
        },

        modalOk(bvModalEvt) {
            bvModalEvt.preventDefault();
            // condivisione completata, fa redirect a backend-gallery
            this.gotoBackendGallery();
        },

        gotoBackendGallery() {
            this.$router.push({
                name: "backend-gallery",
                params: { eventId: this.eventId }
            });
        }
    },

    computed: {
        formValid() {
            // loop over all contents of the fields object and check if they exist and valid.
            return Object.keys(this.$refs.form).every((field) => {
                return this.fields[field] && this.fields[field].valid;
            });
        }
    }
};
</script>

<style scoped>
/* FIXME: correggere l'altezza dell'editor che esce fuori dallo schermo */
@import "~vue2-editor/dist/vue2-editor.css";
@import "~quill/dist/quill.snow.css";

/* override css vue2-editor */
.quillWrapper {
    height: auto;
    border: none;
}
.quillWrapper,
.quillWrapper .ql-snow.ql-toolbar {
    padding: 0px;
}

.quillWrapper .ql-editor {
    min-height: 100px;
}

section,
div.campi-email {
    height: 100%;
}

.scroll-area {
    position: relative;
    margin: auto;
}
</style>
